import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
